// Promo de una línea de venta cerrada: precio tachado → neto en verde y etiqueta con promo y código.
import type { SaleLine } from '@/api/services/retail-wizard/contract';
import { SalePromotionLine } from '@/shared/patterns/SalePromotion';
import { useSaleCoupon } from '../api/useWizardPromotions';
import {
    appliedPromotionName,
    appliedPromotionNames,
    linePromotionView,
} from '../lib/linePromotion';
import type { SaleAudience } from '../lib/saleAudience';

/** El nombre sale del cupón de la venta; sin él, la etiqueta dice el código o «Promoción». */
export function LinePromotionTag({
    line,
    saleId,
    audience,
    couponRetailerId,
}: {
    line: SaleLine;
    saleId: string;
    audience: SaleAudience;
    /** Cadena con la que el admin de tenant lee el cupón. */
    couponRetailerId?: string;
}) {
    const { data } = useSaleCoupon(saleId, {
        audience,
        ...(couponRetailerId !== undefined && { retailerId: couponRetailerId }),
    });
    const applied = data?.appliedPromotions ?? [];
    const view = linePromotionView(
        line,
        appliedPromotionName(applied, line),
        appliedPromotionNames(applied, line),
    );
    if (!view) return null;
    if (view.kind === 'GIFT') {
        return <SalePromotionLine name="Regalo" originalCents={view.valueCents} netCents={0} />;
    }
    return (
        <SalePromotionLine
            name={view.name}
            {...(view.names && { names: view.names })}
            {...(view.code !== undefined && { code: view.code })}
            originalCents={view.discountCents > 0 ? view.originalCents : null}
            netCents={view.finalCents}
        />
    );
}
